var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "3.75 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.0995
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75 0h24v17h-24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 0h24v4.5333h-24zm0 12.467h24v4.5333h-24z",
    fill: "#d03433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 4.5333h24v7.9333h-24z",
    fill: "#fbca46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.07 7.9333h1.0667v0.56667h-1.0667z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.43 9.6333c0 0.34 0.32 0.56667 0.64 0.56667s0.64-0.22667 0.64-0.56667l0.10667-1.7h-1.4933l0.10667 1.7zm-0.64-1.7c0-0.34 0.21333-0.56667 0.42667-0.56667h1.6c0.32 0 0.53333 0.22667 0.53333 0.45333v0.11333l-0.10667 1.7c-0.10667 0.68-0.53333 1.1333-1.1733 1.1333s-1.0667-0.45333-1.1733-1.1333z",
    fill: "#a41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.003 8.5h2.1333v0.56667h-0.53333l-0.53333 1.1333-0.53333-1.1333h-0.53333zm-1.6-1.7h1.0667v3.9667h-1.0667zm4.2667 0h1.0667v3.9667h-1.0667zm-2.6667-0.56667c0-0.34 0.21333-0.56667 0.53333-0.56667h1.0667c0.32 0 0.53333 0.22667 0.53333 0.56667v0.22667c0 0.22667-0.10667 0.34-0.32 0.34h-1.6c-0.10667 0-0.21333-0.11333-0.21333-0.22667z",
    fill: "#a41517"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.1866edb4d61a8753c1abc4c05c5148c0.svg";
export { ForwardRef as ReactComponent };